(() => {
  const initializedScopes = new WeakSet();
  const rememberedCallouts = new WeakMap();

  const positionCallout = (scope) => {
    let callout = rememberedCallouts.get(scope);

    if (!callout) {
      callout = scope.querySelector('.need-it-today');

      if (!callout) return;

      rememberedCallouts.set(scope, callout);
    }

    const consent = scope.querySelector(
      '.shopify-payment-button #shopify-buyer-consent[data-consent-type="subscription"]'
    );

    if (consent) {
      if (callout.nextElementSibling !== consent) {
        consent.before(callout);
      }

      return;
    }

    if (!callout.isConnected) {
      scope.append(callout);
    }
  };

  const initializeScope = (scope) => {
    if (initializedScopes.has(scope)) return;

    const callout = scope.querySelector('.need-it-today');

    if (!callout) return;

    initializedScopes.add(scope);
    rememberedCallouts.set(scope, callout);

    let frameRequested = false;

    const requestPosition = () => {
      if (frameRequested) return;

      frameRequested = true;

      window.requestAnimationFrame(() => {
        positionCallout(scope);
        frameRequested = false;
      });
    };

    const observer = new MutationObserver(requestPosition);

    observer.observe(scope, {
      childList: true,
      subtree: true
    });

    positionCallout(scope);
  };

  const initialize = (root = document) => {
    const scopes = root.querySelectorAll
      ? root.querySelectorAll('.product-form__buttons')
      : [];

    scopes.forEach(initializeScope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialize(),
      { once: true }
    );
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
